import { render, staticRenderFns } from "./FeedVideo.vue?vue&type=template&id=73f542e4&scoped=true&"
import script from "./FeedVideo.vue?vue&type=script&lang=js&"
export * from "./FeedVideo.vue?vue&type=script&lang=js&"
import style0 from "./FeedVideo.vue?vue&type=style&index=0&id=73f542e4&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f542e4",
  null
  
)

export default component.exports